export default "__VITE_ASSET__Dtjmv4xv__"